import moment from "moment-timezone";

/** * Validate the password.
 * @param {object} password - The password object.
 * @returns {string} - The validation message.
 */
export function passwordValidationMessage(password) {
    if (password.$error) {
        if (!password.minLength) {
            return `Password must have at least ${password.$params.minLength.min} letters.`;
        } else if (password.required && password.$model.length < 1) {
            return `Password is required`;
        } else {
            return "Invalid password";
        }
    }
    return "";
}

/** * Validate the email.
 * @param {object} email - The email object.
 * @returns {string} - The validation message.
 */
export function emailValidationMessage(email) {
    if (email.$error) {
        if (!email.required) {
            return "Enter a valid email";
        } else if (!email.email) {
            return "Email is invalid";
        } else if (!email.customValidator) {
            return "Email is already used.";
        }
    }
    return "";
}


/** * Validate birth date (must be at least 18 years old).
 * @param {string|Date} date - The birth date.
 * @returns {boolean} - True if the user is at least 18 years old, false otherwise.
 */
export function validateBirth(date) {
    let today = moment();
    let diff = today.diff(moment(date), "years");
    return diff >= 18 ? true : false;
};